// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Dj2U","bigColWidth":"Table_bigColWidth__dUy1K","biggerColWidth":"Table_biggerColWidth__2bLP9","row":"Table_row__1iitO","col":"Table_col__2bT8P"};